import { render, staticRenderFns } from "./welcomePage.vue?vue&type=template&id=c20cd0ce&"
import script from "./welcomePage.vue?vue&type=script&lang=js&"
export * from "./welcomePage.vue?vue&type=script&lang=js&"
import style0 from "./welcomePage.vue?vue&type=style&index=0&id=c20cd0ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports